import React from 'react';
import { X, Heart, ShoppingCart, Trash2 } from 'lucide-react';
import { useWishlistContext } from '../../context/WishlistContext';
import { useCart } from '../../hooks/useCart';
import { formatVND } from '../../utils/formatters';

export default function WishlistDrawer({ allProducts = [] }) {
    const { isWishlistOpen, closeWishlist, wishlist, toggleWishlist } = useWishlistContext();
    const { addToCart } = useCart();

    if (!isWishlistOpen) return null;

    // Lọc ra danh sách chi tiết các sản phẩm đã được thích từ mảng allProducts truyền vào
    const favoriteProducts = allProducts.filter(product =>
        wishlist.includes(product.id || product.realId)
    );

    return (
        <div className="fixed inset-0 z-50 overflow-hidden">
            {/* Lớp nền mờ khi mở Sidebar */}
            <div
                className="absolute inset-0 bg-black/40 backdrop-blur-xs transition-opacity"
                onClick={closeWishlist}
            />

            <div className="absolute inset-y-0 right-0 max-w-full flex pl-10">
                <div className="w-screen max-w-md bg-white shadow-2xl flex flex-col animate-slideLeft">

                    {/* Header của Sidebar */}
                    <div className="px-6 py-5 border-b border-slate-100 flex items-center justify-between">
                        <div className="flex items-center space-x-2 text-slate-900">
                            <Heart className="w-5 h-5 text-rose-500 fill-rose-500" />
                            <h2 className="text-lg font-bold">Danh Sách Yêu Thích</h2>
                            <span className="text-xs bg-slate-100 px-2 py-0.5 rounded-full font-bold text-slate-600">
                {favoriteProducts.length}
              </span>
                        </div>
                        <button
                            onClick={closeWishlist}
                            className="p-1 rounded-xl hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition cursor-pointer"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>

                    {/* Danh sách sản phẩm bên trong */}
                    <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
                        {favoriteProducts.length === 0 ? (
                            <div className="h-full flex flex-col items-center justify-center text-center text-slate-400 space-y-3">
                                <Heart className="w-12 h-12 text-slate-200" />
                                <p className="text-sm font-medium">Chưa có sản phẩm yêu thích nào</p>
                            </div>
                        ) : (
                            favoriteProducts.map((product) => {
                                const imgUrl = product.thumbnail || product.images?.[0] || 'https://placeholder.com';
                                return (
                                    <div key={product.id || product.realId} className="flex items-center gap-4 p-3 border border-slate-100 rounded-2xl hover:shadow-xs transition">
                                        <img
                                            src={imgUrl}
                                            alt={product.name}
                                            className="w-16 h-16 object-cover rounded-xl bg-slate-50 border shrink-0"
                                        />
                                        <div className="flex-1 min-w-0">
                                            <h4 className="text-xs font-bold text-slate-800 truncate">{product.name}</h4>
                                            <p className="text-sm font-extrabold text-indigo-600 mt-1">{formatVND(product.price ?? 0)}</p>

                                            <div className="flex items-center gap-2 mt-2">
                                                {/* Nút thêm nhanh vào giỏ hàng */}
                                                <button
                                                    onClick={() => addToCart && addToCart(product)}
                                                    className="flex items-center gap-1 bg-slate-900 hover:bg-indigo-600 text-white text-[10px] font-bold px-2.5 py-1.5 rounded-lg transition shadow-xs cursor-pointer"
                                                >
                                                    <ShoppingCart className="w-3 h-3" /> Thêm vào giỏ
                                                </button>
                                                {/* Nút xóa khỏi mục yêu thích */}
                                                <button
                                                    onClick={() => toggleWishlist(product.id || product.realId)}
                                                    className="p-1.5 border border-slate-100 hover:border-rose-100 hover:bg-rose-50 text-slate-400 hover:text-rose-500 rounded-lg transition cursor-pointer"
                                                    title="Xóa khỏi danh sách"
                                                >
                                                    <Trash2 className="w-3.5 h-3.5" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}
